import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'BlessingsWedding',
  dir: 'BlessingsWedding',
  pathRoot: 'loi-chuc-phuc',
  routes: [
    {
      url: ':id',
      component: 'Page',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'BlessingsWedding | Smart Event',
        titleI18n: 'BlessingsWedding:title',
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: 'Any',
};
